import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import './article-page-image-carousel.component.scss';
var ArticlePageImageCarousel = /** @class */ (function (_super) {
    tslib_1.__extends(ArticlePageImageCarousel, _super);
    function ArticlePageImageCarousel(element) {
        return _super.call(this, element) || this;
    }
    ArticlePageImageCarousel.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.windowWidth = document.documentElement.clientWidth;
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    ArticlePageImageCarousel.prototype.bindEvents = function () { };
    return ArticlePageImageCarousel;
}(Base));
export { ArticlePageImageCarousel };



//////////////////
// WEBPACK FOOTER
// ./components/article-page-image-carousel/article-page-image-carousel.component.ts
// module id = 102
// module chunks = 0